(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2639],{

/***/ 49478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Node"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NodeSensor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sensor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}}]}}],"loc":{"start":0,"end":329}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n\\nfragment Node on LineNode {\\n  id\\n  type\\n  peripheralId\\n  sensor {\\n    _id\\n    peripheralId\\n    name\\n    description\\n    config {\\n      ...SensorConfig\\n    }\\n  }\\n}\\n\\nfragment NodeSensor on Sensor {\\n  _id\\n  id\\n  peripheralId\\n  name\\n  description\\n  config {\\n    ...SensorConfig\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));


      module.exports = doc;
    


/***/ }),

/***/ 55918:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"lineDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[]}]}}],"loc":{"start":0,"end":68}}');
    doc.loc.source = JSON.parse('{"body":"mutation lineDelete($lineId: ID!) {\\n  deleteLine(lineId: $lineId)\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.lineDelete = oneQuery(doc, "lineDelete");
        


/***/ }),

/***/ 86563:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"lineUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nodes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LineNodeInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"edges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LineEdgeInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLineWithTopology"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"nodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nodes"}}},{"kind":"Argument","name":{"kind":"Name","value":"edges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"edges"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Node"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSensor"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":643}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/line/node-with-sensor.gql\'\\n\\nmutation lineUpdate(\\n  $lineId: ID!\\n  $name: String!\\n  $description: String!\\n  $nodes: [LineNodeInput!]!\\n  $edges: [LineEdgeInput!]!\\n  $languageCode: String! # $sensorConfig: SensorConfigInput! # $bottleneckId: ID!\\n) {\\n  updateLineWithTopology(\\n    lineId: $lineId\\n    name: $name\\n    description: $description\\n    nodes: $nodes\\n    edges: $edges\\n    languageCode: $languageCode\\n  ) {\\n    id\\n    name\\n    description\\n    nodes {\\n      ...Node\\n      sensor {\\n        ...NodeSensor\\n      }\\n    }\\n    edges {\\n      from\\n      to\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(49478).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.lineUpdate = oneQuery(doc, "lineUpdate");
        


/***/ }),

/***/ 47525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lineSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"mainSensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"peripheralInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfigEnums"},"directives":[]}]}}],"loc":{"start":0,"end":848}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/sensor-config-enums.gql\'\\n\\nquery lineSettings($lineId: ID!) {\\n  line(lineId: $lineId) {\\n    id\\n    name\\n    description\\n    nodes {\\n      id\\n      type\\n      peripheralId\\n      sensor {\\n        _id\\n        peripheralId\\n        name\\n        description\\n        config {\\n          type\\n          ...SensorConfig\\n        }\\n      }\\n    }\\n    edges {\\n      from\\n      to\\n    }\\n    mainSensor {\\n      _id\\n      peripheralId\\n      groups {\\n        id\\n        lineIds\\n        name\\n        sensors {\\n          _id\\n          name\\n          description\\n          peripheralId\\n          config {\\n            type\\n          }\\n          peripheralInformation {\\n            node {\\n              peripheralId\\n            }\\n          }\\n        }\\n      }\\n    }\\n  }\\n  ...SensorConfigEnums\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(79696).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.lineSettings = oneQuery(doc, "lineSettings");
        


/***/ }),

/***/ 37288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6203);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36712);
/* harmony import */ var _mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97591);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53189);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1827);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55537);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _components_dialogs_dialog_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69538);









var DeleteConfirmationDialog = function(param) {
    var open = param.open, onClose = param.onClose, onConfirm = param.onConfirm, t = param.t, title = param.title;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        open: open,
        maxWidth: "xs",
        fullWidth: true,
        "aria-labelledby": "delete-confirmation-dialog",
        onClose: onClose,
        scroll: "body",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_dialogs_dialog_header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: t([
                    "shared:confirmDeletion"
                ], {
                    defaultValue: "Confirm Deletion"
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body2",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        style: {
                            color: theme.palette.error.main
                        },
                        id: "confirmDelete",
                        onClick: onConfirm,
                        children: t([
                            "shared:delete"
                        ], {
                            defaultValue: "Delete"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        id: "cancelDeletionAndClose",
                        onClick: onClose,
                        children: t([
                            "shared:cancel"
                        ], {
                            defaultValue: "Cancel"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DeleteConfirmationDialog);


/***/ }),

/***/ 22639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ line_settings_dialog; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(426);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(6203);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(36712);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(97591);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(53189);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(15506);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(29787);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-form-validator-core@0.6.5_react-dom@17.0.2_react@17.0.2/node_modules/react-form-validator-core/lib/index.js
var lib = __webpack_require__(8081);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ./components/dialogs/dialog-header.tsx
var dialog_header = __webpack_require__(69538);
// EXTERNAL MODULE: ./components/dialogs/discard-changes-dialog.tsx
var discard_changes_dialog = __webpack_require__(49153);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(67223);
// EXTERNAL MODULE: ./graphql/queries/line-settings.gql
var line_settings = __webpack_require__(47525);
var line_settings_default = /*#__PURE__*/__webpack_require__.n(line_settings);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(83126);
// EXTERNAL MODULE: ./hooks/use-width.ts
var use_width = __webpack_require__(31906);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(48578);
// EXTERNAL MODULE: ./views/common-components/wrap-required-fileds-description.tsx
var wrap_required_fileds_description = __webpack_require__(65783);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(90918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.3/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(76398);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(79031);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(70333);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.22.5_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(95840);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./components/buttons/mutation-button.tsx
var mutation_button = __webpack_require__(24024);
// EXTERNAL MODULE: ./graphql/mutations/line-delete.gql
var line_delete = __webpack_require__(55918);
var line_delete_default = /*#__PURE__*/__webpack_require__.n(line_delete);
// EXTERNAL MODULE: ./hocs/with-iam.tsx
var with_iam = __webpack_require__(67337);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(79857);
// EXTERNAL MODULE: ./views/dialogs/confirm/delete-confirmation-dialog.tsx
var delete_confirmation_dialog = __webpack_require__(37288);
;// CONCATENATED MODULE: ./views/dialogs/line-settings/delete-button.tsx



















var DeleteButton = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DeleteButton, _Component);
    var _super = (0,_create_super/* default */.Z)(DeleteButton);
    function DeleteButton() {
        (0,_class_call_check/* default */.Z)(this, DeleteButton);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            clearCache: Function.prototype,
            openConfirmationDialog: false
        };
        // tslint:disable-next-line
        _this.onUpdate = function(proxy, _) {
            // For properly deleting line in cache
            // Try to fix in Apollo 3
            _this.setState({
                clearCache: function() {
                    delete proxy.data.data["Line:".concat(_this.props.lineId)];
                }
            });
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onCompleted = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!data) {
                                return [
                                    2
                                ];
                            }
                            _this1.props.handleOpenClose(!_this1.props.open);
                            if (_this1.state.clearCache) {
                                _this1.state.clearCache();
                            }
                            return [
                                4,
                                router_default().replace("/lines")
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onDelete = function(mutation) {
            return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        mutation({
                            variables: {
                                lineId: _this2.props.lineId
                            }
                        })
                    ];
                });
            });
        };
        _this.openConfirmationDialog = function() {
            return _this.setState({
                openConfirmationDialog: true
            });
        };
        _this.closeConfirmationDialog = function() {
            return _this.setState({
                openConfirmationDialog: false
            });
        };
        return _this;
    }
    var _proto = DeleteButton.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, lineId = _props.lineId, hasLineFeatures = _props.hasLineFeatures, width = _props.width, theme = _props.theme, t = _props.t, disabledMessage = _props.disabledMessage, refetchQueries = _props.refetchQueries;
        var MutationBtn = (0,with_width/* isWidthUp */.yJ)("md", width) ? mutation_button/* MutationButton */.j : mutation_button/* MutationIconButton */.t;
        var styling = (0,with_width/* isWidthUp */.yJ)("md", width) ? {
            margin: theme.spacing()
        } : {};
        var iconStyles = (0,with_width/* isWidthUp */.yJ)("md", width) ? {
            marginRight: theme.spacing(),
            marginTop: "-3px"
        } : {};
        var label = t([
            "line:deleteLine"
        ], {
            defaultValue: "Delete line"
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, {
            mutation: (line_delete_default()),
            update: this.onUpdate,
            refetchQueries: refetchQueries,
            onCompleted: this.onCompleted,
            children: function(mutation, param) {
                var mutationLoading = param.loading;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MutationBtn, {
                            withIcon: true,
                            isRed: true,
                            "aria-label": label,
                            style: styling,
                            loading: mutationLoading,
                            onClick: _this.openConfirmationDialog,
                            disabled: !hasLineFeatures(lineId, [
                                "Lines.Line"
                            ], "M"),
                            tooltipMsg: (0,with_width/* isWidthUp */.yJ)("md", width) ? "" : label,
                            tooltipMsgDisabled: disabledMessage ? disabledMessage : t([
                                "shared:noPermissionToEdit"
                            ], {
                                defaultValue: "You don't have permission to edit this"
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                                    style: iconStyles
                                }),
                                (0,with_width/* isWidthUp */.yJ)("md", width) ? label : ""
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(delete_confirmation_dialog/* default */.Z, {
                            open: _this.state.openConfirmationDialog,
                            onClose: _this.closeConfirmationDialog,
                            onConfirm: _this.onDelete(mutation),
                            t: t,
                            title: t([
                                "line:confirmLineDeletion"
                            ], {
                                defaultValue: "Are you sure you wish to delete this line?"
                            })
                        })
                    ]
                });
            }
        });
    };
    return DeleteButton;
}(react.Component);
var enhanceSave = (0,Recompose_esm/* compose */.qC)(router.withRouter, (0,with_width/* withWidth */.of)(), with_iam/* withIAM */.$, (0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line"
]), (0,with_styles/* withStyles */.D)(function() {
    return {};
}, {
    withTheme: true
}));
/* harmony default export */ var delete_button = (enhanceSave(DeleteButton));

// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/select-sensor.tsx
var select_sensor = __webpack_require__(78498);
// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/specify-line-info.tsx
var specify_line_info = __webpack_require__(86038);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(2651);
// EXTERNAL MODULE: ./graphql/mutations/line-update.gql
var line_update = __webpack_require__(86563);
var line_update_default = /*#__PURE__*/__webpack_require__.n(line_update);
;// CONCATENATED MODULE: ./views/dialogs/line-settings/update-button.tsx
















var UpdateButton = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(UpdateButton, _Component);
    var _super = (0,_create_super/* default */.Z)(UpdateButton);
    function UpdateButton() {
        (0,_class_call_check/* default */.Z)(this, UpdateButton);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleOpenClose = function(data) {
            if (!data) {
                return;
            }
            return _this.props.handleOpenClose(!_this.props.open);
        };
        _this.onUpdateLine = function(updateLine, variables) {
            return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        updateLine({
                            variables: variables
                        })
                    ];
                });
            });
        };
        return _this;
    }
    var _proto = UpdateButton.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, hasLineFeatures = _props.hasLineFeatures, width = _props.width, theme = _props.theme, t = _props.t, disabledMessage = _props.disabledMessage, lineId = _props.lineId, lineInfo = _props.lineInfo, nodes = _props.nodes, edges = _props.edges, languageCode = _props.languageCode, refetchQueries = _props.refetchQueries;
        var MutationBtn = (0,with_width/* isWidthUp */.yJ)("md", width) ? mutation_button/* MutationButton */.j : mutation_button/* MutationIconButton */.t;
        var styling = (0,with_width/* isWidthUp */.yJ)("md", width) ? {
            margin: theme.spacing()
        } : {};
        var iconStyles = (0,with_width/* isWidthUp */.yJ)("md", width) ? {
            marginRight: theme.spacing(),
            marginTop: "-3px"
        } : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, {
            mutation: (line_update_default()),
            onCompleted: this.handleOpenClose,
            awaitRefetchQueries: true,
            refetchQueries: refetchQueries,
            children: function(updateLine, param) {
                var mutationLoading = param.loading;
                var label = t([
                    "line:updateLineSettings"
                ], {
                    defaultValue: "Update line settings"
                });
                var variables = {
                    lineId: lineId,
                    name: lineInfo.name,
                    description: lineInfo.description,
                    nodes: nodes,
                    edges: edges,
                    languageCode: languageCode
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MutationBtn, {
                    withIcon: true,
                    color: "primary",
                    "aria-label": label,
                    style: styling,
                    loading: mutationLoading,
                    onClick: _this.onUpdateLine(updateLine, variables),
                    disabled: !hasLineFeatures(lineId, [
                        "Lines.Line"
                    ], "M"),
                    tooltipMsg: (0,with_width/* isWidthUp */.yJ)("md", width) ? "" : label,
                    tooltipMsgDisabled: disabledMessage ? disabledMessage : t([
                        "shared:noPermissionToEdit"
                    ], {
                        defaultValue: "You don't have permission to edit this"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                            style: iconStyles
                        }),
                        (0,with_width/* isWidthUp */.yJ)("md", width) ? label : ""
                    ]
                });
            }
        });
    };
    return UpdateButton;
}(react.Component);
var update_button_enhanceSave = (0,Recompose_esm/* compose */.qC)((0,with_width/* withWidth */.of)(), with_iam/* withIAM */.$, (0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line"
]), (0,with_styles/* withStyles */.D)(function() {
    return {};
}, {
    withTheme: true
}));
/* harmony default export */ var update_button = (update_button_enhanceSave(UpdateButton));

// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/line-list-topology.tsx + 1 modules
var line_list_topology = __webpack_require__(93271);
;// CONCATENATED MODULE: ./views/dialogs/line-settings/line-settings-dialog.tsx






























var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        formContainer: (0,_define_property/* default */.Z)({
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column"
        }, theme.breakpoints.up("md"), {
            padding: "40px"
        }),
        textFields: {
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
            marginTop: "20px"
        },
        closeButton: {
            marginRight: theme.spacing(),
            marginTop: "-3px"
        },
        dialogActions: {
            justifyContent: "space-between"
        }
    };
});
var LineSettingsDialog = function(props) {
    var classes = useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 2), t = ref[0], i18n = ref[1];
    var width = (0,use_width/* useWidth */.z)();
    var open = props.open, handleOpenClose = props.handleOpenClose, key = props.key, refetchQueries = props.refetchQueries, deleteRefetchQueries = props.deleteRefetchQueries, ignoreDiscardValidation = props.ignoreDiscardValidation, lineId = props.lineId;
    var ref1 = (0,react.useState)(null), sensorGroup = ref1[0], setSensorGroup = ref1[1];
    var ref2 = (0,react.useState)([]), nodes = ref2[0], setNodes = ref2[1];
    var ref3 = (0,react.useState)([]), links = ref3[0], setLinks = ref3[1];
    var ref4 = (0,react.useState)(null), bottleneckSensor = ref4[0], setBottleneckSensor = ref4[1];
    var ref5 = (0,react.useState)({
        name: "",
        description: ""
    }), lineInfo = ref5[0], setLineInfo = ref5[1];
    var ref6 = (0,react.useState)(/*#__PURE__*/ react.createRef()), formRef = ref6[0], setFormRef = ref6[1];
    var ref7 = (0,react.useState)(false), hasChanges = ref7[0], setHasChanges = ref7[1];
    var ref8 = (0,react.useState)(false), discardDialogOpen = ref8[0], setDiscardDialogOpen = ref8[1];
    var waitingOnData = !lineInfo || !lineInfo.name && !sensorGroup;
    var errorFetchingData = !waitingOnData && !sensorGroup && new Error("Sensor Group appeared to be undefined!");
    var ref9 = (0,client.useQuery)((line_settings_default()), {
        ssr: false,
        skip: !open,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        partialRefetch: true,
        onCompleted: function(data) {
            return onCompleted(data);
        },
        variables: {
            lineId: lineId
        }
    }), loading = ref9.loading, error = ref9.error, data = ref9.data;
    var onCompleted = function(data) {
        if (!isEmpty_default()(data) && !lineInfo || !lineInfo.name) {
            var ref, ref1;
            var bottleneckSensor = ((ref1 = data === null || data === void 0 ? void 0 : (ref = data.line) === null || ref === void 0 ? void 0 : ref.nodes.filter(function(node) {
                return node.type === schema/* NodeType.Main */.Jq.Main;
            })[0]) === null || ref1 === void 0 ? void 0 : ref1.sensor) || null;
            setBottleneckSensor(bottleneckSensor);
            setNodes(reshapeFetchedNodes(data.line.nodes.filter(function(node) {
                return node.type !== schema/* NodeType.Main */.Jq.Main;
            })));
            setLinks(reshapeFetchedEdges(data.line.edges));
            setSensorGroup(getSensorGroup(data));
            setLineInfo({
                name: data.line.name,
                description: data.line.description || ""
            });
        }
    };
    var handleReset = function() {
        setFormRef(/*#__PURE__*/ react.createRef());
        setNodes([]);
        setLinks([]);
        setSensorGroup(null);
        setBottleneckSensor(null);
        setLineInfo({
            name: "",
            description: ""
        });
        setHasChanges(false);
        setDiscardDialogOpen(false);
    };
    var handleCloseAndReset = function(discard) {
        return function() {
            if (hasChanges && !ignoreDiscardValidation && !discard) {
                setDiscardDialogOpen(true);
            } else {
                handleReset();
                handleOpenClose(false);
            }
        };
    };
    var handleDiscardResponse = function(discard) {
        if (discard) {
            handleReset();
            handleOpenClose(false);
        } else {
            setDiscardDialogOpen(false);
        }
    };
    var sensorIsPartOfALine = function(sensor) {
        var ref, ref1;
        return sensor === null || sensor === void 0 ? void 0 : (ref = sensor.peripheralInformation) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.peripheralId;
    };
    var reshapeNodes = function(nodes, nodeLinks) {
        return nodes.map(function(node) {
            // Mark selected scrap sensors as such
            var isScrapSensor = nodeLinks.find(function(x) {
                return x.source === node.peripheralId && x.target === (bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId) || x.source === (bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId) && x.target === node.peripheralId;
            });
            var nodeType;
            if (node.nodeType === schema/* NodeType.Main */.Jq.Main) {
                nodeType = node.nodeType;
            } else if (isScrapSensor) {
                nodeType = schema/* NodeType.Scrap */.Jq.Scrap;
            } else {
                nodeType = sensorTypeToNodeType(node.sensorType);
            }
            return {
                type: nodeType,
                peripheralId: node.peripheralId
            };
        });
    };
    var reshapeLinks = function(links) {
        return links ? links.map(function(link) {
            return {
                from: link.source,
                to: link.target
            };
        }) : [];
    };
    var reshapeFetchedNodes = function(nodes) {
        var reshaped = nodes.filter(helper_types/* isTruthy */.f).map(function(node) {
            var ref, ref1, ref2, ref3;
            return {
                sensorName: (ref = node.sensor) === null || ref === void 0 ? void 0 : ref.name,
                sensorDescription: (ref1 = node.sensor) === null || ref1 === void 0 ? void 0 : ref1.description,
                peripheralId: (ref2 = node.sensor) === null || ref2 === void 0 ? void 0 : ref2.peripheralId,
                nodeType: node.type || schema/* NodeType.Counter */.Jq.Counter,
                registerStops: node.type === schema/* NodeType.Main */.Jq.Main,
                oee: node.type === schema/* NodeType.Main */.Jq.Main,
                sensorType: (ref3 = node.sensor) === null || ref3 === void 0 ? void 0 : ref3.config.type
            };
        });
        return reshaped;
    };
    var reshapeFetchedEdges = function(edges) {
        var graphEdges = edges.filter(function(edge) {
            return edge.from && edge.to;
        }).map(function(edge) {
            var newGraphLink = {
                source: edge.from,
                target: edge.to
            };
            return newGraphLink;
        });
        return graphEdges;
    };
    var handleClose = function() {
        handleCloseAndReset(!open)();
    };
    var notImplemented = function() {};
    var getSensorGroup = function(data) {
        var ref, ref1, ref2;
        var group = (data === null || data === void 0 ? void 0 : (ref = data.line) === null || ref === void 0 ? void 0 : (ref1 = ref.mainSensor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.groups) === null || ref2 === void 0 ? void 0 : ref2.find(function(group) {
            return group.lineIds.find(function(id) {
                return id === data.line.id;
            }) !== undefined;
        })) || null;
        var sensorGroup = {
            id: group === null || group === void 0 ? void 0 : group.id,
            name: group === null || group === void 0 ? void 0 : group.name,
            sensors: group === null || group === void 0 ? void 0 : group.sensors,
            availableSensors: group === null || group === void 0 ? void 0 : group.sensors.filter(function(sensor) {
                return sensor && (!sensorIsPartOfALine(sensor) || data.line.nodes.some(function(node) {
                    return sensor.peripheralId === node.peripheralId;
                }));
            }),
            unavailableSensors: group === null || group === void 0 ? void 0 : group.sensors.filter(function(s) {
                return s && sensorIsPartOfALine(s);
            })
        };
        return sensorGroup;
    };
    var sensorTypeToNodeType = function(sensorType) {
        if (!sensorType) {
            return schema/* NodeType.Counter */.Jq.Counter;
        }
        switch(sensorType){
            case schema/* SensorType.COUNTER */.dE.COUNTER:
            case schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE:
            case schema/* SensorType.COUNTER_SPEED */.dE.COUNTER_SPEED:
            case schema/* SensorType.DISCRETE */.dE.DISCRETE:
            case schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS:
            case schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT:
                return schema/* NodeType.Counter */.Jq.Counter;
            case schema/* SensorType.EVENT */.dE.EVENT:
                return schema/* NodeType.Event */.Jq.Event;
            default:
                console.warn("Unrecognized sensor type!");
                return schema/* NodeType.Counter */.Jq.Counter;
        }
    };
    var onAddScrapSensorNode = function(peripheralId, isBeforeMain) {
        var updatedLinks = (0,_to_consumable_array/* default */.Z)(links);
        var source = isBeforeMain ? peripheralId : bottleneckSensor.peripheralId;
        var target = isBeforeMain ? bottleneckSensor.peripheralId : peripheralId;
        updatedLinks.push({
            source: source,
            target: target
        });
        setLinks(updatedLinks);
    };
    var onRemoveScrapSensorNode = function(peripheralId) {
        var updatedLinks = links.filter(function(link) {
            return link.source !== peripheralId && link.target !== peripheralId;
        });
        setLinks(updatedLinks);
    };
    var onSelectBottleneckSensor = (0,react.useCallback)(function(sensor) {
        if (sensor.peripheralId === (bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId)) {
            return;
        }
        setBottleneckSensor(sensor);
        setNodes(nodes.filter(function(node) {
            return node.peripheralId !== sensor.peripheralId;
        }));
    }, [
        nodes,
        setNodes,
        setBottleneckSensor
    ]);
    var onSelectSensorWithLineSettings = function(sensor) {
        var isCamera = sensor.peripheralType === schema/* PeripheralType.CAMERA */.Ti.CAMERA;
        var existingSensorNode = nodes.find(function(node) {
            return node.peripheralId === sensor.peripheralId;
        });
        var id = existingSensorNode === null || existingSensorNode === void 0 ? void 0 : existingSensorNode.peripheralId;
        if (existingSensorNode && existingSensorNode.nodeType !== schema/* NodeType.Main */.Jq.Main) {
            var updatedNodes = nodes.filter(function(node) {
                return node.peripheralId !== id && node.peripheralId !== (bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId);
            });
            var updatedLinks = links.filter(function(link) {
                return link.source !== id && link.target !== id;
            });
            setNodes(updatedNodes);
            setLinks(updatedLinks);
        } else if (!nodes.some(function(node) {
            return node.peripheralId === sensor.peripheralId;
        })) {
            var newGraphNode = {
                sensorName: sensor.name,
                sensorDescription: sensor.description,
                peripheralId: sensor.peripheralId,
                sensorType: sensor.config.type,
                nodeType: isCamera ? schema/* NodeType.Camera */.Jq.Camera : sensorTypeToNodeType(sensor.config.type),
                registerStops: false,
                oee: false
            };
            setNodes((0,_to_consumable_array/* default */.Z)(nodes).concat([
                newGraphNode
            ]));
        }
    };
    var renderContent = function() {
        var ref;
        if (loading || error && !data || waitingOnData || errorFetchingData) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                loading: loading || waitingOnData,
                error: error || errorFetchingData
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 2,
            alignItems: "stretch",
            justifyContent: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specify_line_info/* default */.Z, {
                        lineInfo: lineInfo,
                        onChangeLineInfo: setLineInfo
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor/* default */.Z, {
                        title: t([
                            "line:selectBottleneckCounter"
                        ], {
                            defaultValue: "Select the bottleneck (main sensor) of the line"
                        }) + "*",
                        disabledSensorId: undefined,
                        sensors: ((sensorGroup === null || sensorGroup === void 0 ? void 0 : sensorGroup.availableSensors) || []).filter(helper_types/* isTruthy */.f),
                        selectedSensorIds: bottleneckSensor ? [
                            bottleneckSensor.peripheralId
                        ] : [],
                        onSelectSensor: onSelectBottleneckSensor,
                        selectDefault: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor/* default */.Z, {
                        title: t([
                            "line:clickSensorToAddOrRemove"
                        ], {
                            defaultValue: "Click on a sensor to add or remove it from the line"
                        }),
                        selectedSensorIds: nodes.map(function(node) {
                            return node.peripheralId;
                        }),
                        sensors: (sensorGroup === null || sensorGroup === void 0 ? void 0 : (ref = sensorGroup.availableSensors) === null || ref === void 0 ? void 0 : ref.filter(helper_types/* isTruthy */.f)) || [],
                        onSelectSensor: onSelectSensorWithLineSettings,
                        disabledSensorId: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_list_topology/* default */.Z, {
                        // Only non-bottleneck and counter sensors can be scrap
                        availableNodes: nodes.filter(function(node) {
                            return node.nodeType !== schema/* NodeType.Main */.Jq.Main && (node.sensorType === schema/* SensorType.COUNTER */.dE.COUNTER || node.sensorType === schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE);
                        }),
                        mainSensorNodeName: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.name,
                        mainSensorNodePeripheralId: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId,
                        nodeLinks: links,
                        onAddScrapSensor: onAddScrapSensorNode,
                        onRemoveScrapSensor: onRemoveScrapSensorNode
                    })
                })
            ]
        });
    };
    var allNodes = (0,_to_consumable_array/* default */.Z)(nodes).concat([
        {
            sensorName: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.name,
            sensorDescription: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.description,
            peripheralId: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId,
            sensorType: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.config.type,
            nodeType: schema/* NodeType.Main */.Jq.Main,
            registerStops: false,
            oee: false
        }, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: open,
        maxWidth: "md",
        fullWidth: true,
        onClose: handleClose,
        scroll: "body",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* ValidatorForm */.WS, {
                ref: formRef,
                method: "post",
                instantValidate: true,
                onSubmit: notImplemented,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                        title: t([
                            "line:manageLineSettings"
                        ], {
                            defaultValue: "Manage line settings"
                        }),
                        onClose: handleClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        children: [
                            renderContent(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap_required_fileds_description/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                        className: classes.dialogActions,
                        children: !waitingOnData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(delete_button, {
                                    lineId: lineId,
                                    handleOpenClose: handleOpenClose,
                                    open: open,
                                    refetchQueries: deleteRefetchQueries
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                            onClick: function() {
                                                return handleOpenClose(false);
                                            },
                                            color: "primary",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                                    className: classes.closeButton
                                                }),
                                                (0,with_width/* isWidthUp */.yJ)("md", width) ? t([
                                                    "shared:discardChanges"
                                                ], {
                                                    defaultValue: "Discard changes"
                                                }) : ""
                                            ]
                                        }),
                                        bottleneckSensor && /*#__PURE__*/ (0,jsx_runtime.jsx)(update_button, {
                                            lineId: lineId,
                                            lineInfo: lineInfo,
                                            nodes: reshapeNodes(allNodes, links),
                                            edges: reshapeLinks(links),
                                            languageCode: i18n.language ? i18n.language : "",
                                            handleOpenClose: handleOpenClose,
                                            open: open,
                                            refetchQueries: refetchQueries
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    })
                ]
            }, key),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(discard_changes_dialog/* default */.Z, {
                open: discardDialogOpen,
                handleResponse: handleDiscardResponse
            })
        ]
    });
};
/* harmony default export */ var line_settings_dialog = (LineSettingsDialog);


/***/ }),

/***/ 93271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ line_list_topology; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/ArrowForward.js
var ArrowForward = __webpack_require__(77131);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(41828);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(47586);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(62734);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(77161);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(87746);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(84074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(60945);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(53888);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(35192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(68368);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(30810);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Autocomplete/Autocomplete.js
var Autocomplete = __webpack_require__(41791);
// EXTERNAL MODULE: ./helpers/input.tsx
var input = __webpack_require__(49301);
;// CONCATENATED MODULE: ./views/dialogs/line-settings/setup-line/add-scrap-sensor.tsx












var AddScapSensor = function(props) {
    var availableNodes = props.availableNodes, setupNodes = props.setupNodes, title = props.title, onAddScrapSensor = props.onAddScrapSensor, onRemoveScrapSensor = props.onRemoveScrapSensor;
    var ref = (0,react.useState)([]), searchValues = ref[0], setSearchValues = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref1[0];
    (0,react.useEffect)(function() {
        var newSearchValues = setupNodes.map(function(node) {
            return {
                id: node.peripheralId,
                label: node.sensorName
            };
        });
        setSearchValues(newSearchValues);
    }, [
        setupNodes
    ]);
    var onAutocompleteChange = function(value) {
        var previousSensors = searchValues.filter(function(s) {
            return (0,input/* isSearchValueType */.o)(s);
        }).map(function(s) {
            return s;
        });
        var newSensors = value.filter(function(s) {
            return (0,input/* isSearchValueType */.o)(s);
        }).map(function(s) {
            return s;
        });
        if (previousSensors.length < newSensors.length) {
            var addedSensors = newSensors.filter(function(s) {
                return !previousSensors.some(function(node) {
                    return node.id === s.id;
                });
            });
            addedSensors.forEach(function(s) {
                return onAddScrapSensor(s.id);
            });
        }
        if (newSensors.length < previousSensors.length) {
            var removedSensors = previousSensors.filter(function(prevSensor) {
                return !newSensors.some(function(newSensor) {
                    return prevSensor.id === newSensor.id;
                });
            });
            removedSensors.forEach(function(s) {
                return onRemoveScrapSensor(s.id);
            });
        }
        setSearchValues(value);
    };
    var renderAutocomplete = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
            filterSelectedOptions: true,
            disableCloseOnSelect: true,
            isOptionEqualToValue: function(option, value) {
                return (0,input/* isSearchValueType */.o)(option) && (0,input/* isSearchValueType */.o)(value) ? option.id === value.id : option === value;
            },
            value: searchValues,
            onChange: function(event, value) {
                return onAutocompleteChange(value);
            },
            getOptionLabel: function(option) {
                return (0,input/* isSearchValueType */.o)(option) ? option.label : option;
            },
            multiple: true,
            id: "tags-standard",
            options: availableNodes.map(function(node) {
                return {
                    id: node.peripheralId,
                    label: node.sensorName
                };
            }),
            renderInput: function(params) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    fullWidth: true,
                    variant: "filled",
                    label: t("line:selectSensor", "Select sensor")
                }));
            },
            noOptionsText: t("line:noAvailableSensors", "No available sensors. Please add counters to the line")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        elevation: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: renderAutocomplete()
            })
        ]
    });
};
/* harmony default export */ var add_scrap_sensor = (AddScapSensor);

;// CONCATENATED MODULE: ./views/dialogs/line-settings/setup-line/line-list-topology.tsx

















var useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        container: {
            alignItems: "center"
        },
        scrapContainer: {
            marginTop: "20px",
            marginBottom: "20px"
        },
        item: {
            alignSelf: "center",
            justifySelf: "center",
            display: "flex"
        },
        centered: {
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "auto",
            marginBottom: "auto"
        }
    };
});
var LineListTopology = function(props) {
    var mainSensorNodePeripheralId = props.mainSensorNodePeripheralId, mainSensorNodeName = props.mainSensorNodeName, availableNodes = props.availableNodes, nodeLinks = props.nodeLinks, onAddScrapSensor = props.onAddScrapSensor, onRemoveScrapSensor = props.onRemoveScrapSensor;
    var classes = useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var nodesBeforeMain = availableNodes.filter(function(node) {
        return nodeLinks.some(function(link) {
            return link.source === node.peripheralId && link.target === mainSensorNodePeripheralId;
        });
    });
    var nodesAfterMain = availableNodes.filter(function(node) {
        return nodeLinks.some(function(link) {
            return link.source === mainSensorNodePeripheralId && link.target === node.peripheralId;
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                "aria-controls": "panel1a-content",
                id: "panel1a-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("line:setupScrapSensors", "Specify scrap sensor placement")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: t("line:setupScrapSensorsInfo", "To correctly calculate the number of items produced, please indicate the placement of all scrap sensors on the line"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                fontSize: "small"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    className: classes.container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: classes.scrapContainer,
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_scrap_sensor, {
                                title: t("line:priorToBottleneck", "Scrap sensors prior to bottleneck"),
                                availableNodes: availableNodes.filter(function(n) {
                                    return !nodesAfterMain.some(function(n2) {
                                        return n2.peripheralId === n.peripheralId;
                                    });
                                }),
                                setupNodes: nodesBeforeMain,
                                onAddScrapSensor: function(sensorId) {
                                    return onAddScrapSensor(sensorId, true);
                                },
                                onRemoveScrapSensor: function(sensorId) {
                                    return onRemoveScrapSensor(sensorId);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: classes.item,
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                                mdDown: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        className: classes.centered
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                        size: "medium",
                                        label: "".concat(mainSensorNodeName, " (").concat(t("line:bottleneckSensor", "bottleneckSensor"), ")")
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        className: classes.centered
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: classes.scrapContainer,
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_scrap_sensor, {
                                title: t("line:afterBottleneck", "Scrap sensors after bottleneck"),
                                availableNodes: availableNodes.filter(function(n) {
                                    return !nodesBeforeMain.some(function(n2) {
                                        return n2.peripheralId === n.peripheralId;
                                    });
                                }),
                                setupNodes: nodesAfterMain,
                                onAddScrapSensor: function(sensorId) {
                                    return onAddScrapSensor(sensorId, false);
                                },
                                onRemoveScrapSensor: function(sensorId) {
                                    return onRemoveScrapSensor(sensorId);
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var line_list_topology = (LineListTopology);


/***/ }),

/***/ 78498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53888);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35192);
/* harmony import */ var _mui_material_Chip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84074);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60945);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        sensorCard: {
            maxHeight: "180px",
            overflowY: "scroll",
            margin: "10px"
        },
        sensorChip: {
            marginRight: theme.spacing(0.5),
            marginBottom: theme.spacing(1)
        },
        unselected: {
            color: "black"
        },
        selected: {
            color: "white"
        }
    };
});
var SelectSensor = function(props) {
    var title = props.title, sensors = props.sensors, selectedSensorIds = props.selectedSensorIds, onSelectSensor = props.onSelectSensor, disabledSensorId = props.disabledSensorId;
    var classes = useStyles().classes;
    var sortedSensors = sensors.sort(function(l, r) {
        return l.name.localeCompare(r.name);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        elevation: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "subtitle1",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.sensorCard,
                    children: sortedSensors.map(function(sensor) {
                        var sensorSelected = selectedSensorIds.some(function(sensorId) {
                            return sensorId === sensor.peripheralId && sensorId !== disabledSensorId;
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            placement: "top",
                            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        children: sensor.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    sensor.description
                                ]
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Chip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                label: sensor.name,
                                onClick: function() {
                                    return onSelectSensor(sensor);
                                },
                                className: "".concat(sensorSelected ? classes.selected : classes.unselected, " ").concat(classes.sensorChip),
                                variant: sensorSelected ? "filled" : "outlined",
                                color: "primary",
                                disabled: sensor.peripheralId === disabledSensorId
                            }, "".concat(sensor.name, "-").concat(sensor.peripheralId, "-chip"))
                        }, "".concat(sensor.name, "-").concat(sensor.peripheralId, "-tooltip"));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectSensor);


/***/ }),

/***/ 86038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53888);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35192);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30810);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);










var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        textFields: {
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
            marginTop: "20px"
        }
    };
});
var SpecifyLineInfo = function(param) {
    var lineInfo = param.lineInfo, onChangeLineInfo = param.onChangeLineInfo;
    var classes = useStyles().classes;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)(), 1), t = ref[0];
    var updateLineInfo = function(field) {
        return function(e) {
            var newLineInfo = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, lineInfo);
            newLineInfo[field] = e.target.value;
            onChangeLineInfo(newLineInfo);
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        elevation: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    align: "center",
                    variant: "subtitle1",
                    children: t([
                        "line:lineSettings"
                    ], {
                        defaultValue: "Line Settings"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    variant: "filled",
                    id: "select-line-name",
                    value: lineInfo.name,
                    className: classes.textFields,
                    type: "text",
                    required: true,
                    error: lineInfo.name.length === 0,
                    fullWidth: true,
                    onChange: updateLineInfo("name"),
                    label: t([
                        "line:lineName"
                    ], {
                        defaultValue: "Line name"
                    })
                }, "select-line-name"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    variant: "filled",
                    id: "select-line-description",
                    value: lineInfo.description,
                    className: classes.textFields,
                    type: "text",
                    fullWidth: true,
                    onChange: updateLineInfo("description"),
                    label: t([
                        "line:lineDescription"
                    ], {
                        defaultValue: "Line description"
                    })
                }, "select-line-description")
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SpecifyLineInfo);


/***/ })

}]);